import React from 'react';
import styled, {css} from "styled-components";
import LineLoader from "./Loader/LineLoader";

export const StyledDataBlock = styled.div`
  ${({$maxSize}) => $maxSize && css`
    padding: 15px 77px !important;
  `}
  position: relative;
  padding: 15px 142px;

  .data-block__label {
    font-style: normal;
    font-weight: 400;
    font-size: 28px;
    line-height: 38px;

    display: flex;
    align-items: center;
    text-align: center;

    justify-content: center;

    color: #000000;

    margin-bottom: 24px;
    margin-top: 5px;
  }
`;

const DataBlock = ({label = '', children, maxSize = false}) => {
    return (
        <StyledDataBlock $maxSize={maxSize}>
            <div className='data-block__label'>
                {label}
            </div>
            {children}
        </StyledDataBlock>
    );
};

export default DataBlock;


// WEBPACK FOOTER //
// ./App/components/DataBlock.jsx